import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiResponse } from "utilities/apiUtils";
import { useCustomQuery } from "utilities/hookutils";

const timetableCache = "timetables";

export const useTimetablesApi = (showId: number) => {
  return useCustomQuery({
    queryKey: [timetableCache, showId],
    queryFn: async () => window.CoreApi.Timetable.ListTimetableEntries(showId).then(r => r.data),
    initialData: apiResponse.success([])
  });
};

export const useCreateTimetable = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: window.CoreApi.Timetable.CreateTimetableEntry,
    onSuccess: () => {
      queryClient.invalidateQueries([timetableCache]);
    },
    retry: false
  });
};

export const useEditTimetable = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: window.CoreApi.Timetable.UpdateEntry,
    onSuccess: () => {
      queryClient.invalidateQueries([timetableCache]);
    },
    retry: false
  });
};

export const useDeleteTimetable = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: window.CoreApi.Timetable.DeleteEntry,
    onSuccess: () => {
      queryClient.invalidateQueries([timetableCache]);
    },
    retry: false
  });
};

export const useCleanTimetableCache = () => {
  const queryClient = useQueryClient();
  return async () => queryClient.invalidateQueries([timetableCache]);
};